const scrollTo = (startTop, to, duration) => {
    let start = window.scrollY,
        change = to - start,
        currentTime = 0,
        increment = 20;

    let animateScroll = () => {
        currentTime += increment;
        let val = Math.easeInOutQuad(currentTime, start, change, duration);
        window.scroll(0, val);
        if (currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

const scrollDown = (e) => {
    let self = e.target.parentNode;
    let offset = self.getBoundingClientRect();
    let scroll = self.offsetTop;
    scrollTo(self.top, (offset.height + scroll) -100, 1250)
}


Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
};

export{
    scrollDown,
    scrollTo
}


// WEBPACK FOOTER //
// ./src/static/scrollAnimation.js